import { useLang } from "../i18n";

export function Marquee() {
    const { t } = useLang();
    const items = t.marquee;
    const row = [...items, ...items, ...items];
    return (
        <div className="relative overflow-hidden border-y border-white/10 bg-[#13131A] py-4" data-testid="editorial-marquee">
            <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
                {[...row, ...row].map((item, i) => (
                    <span key={i} className="flex items-center gap-8">
                        <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#8E8EA0]">{item}</span>
                        <span className="text-[#FFB800]">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
